import { h } from 'preact';
import * as BaseComp from 'components/bolt/showtimes/showtimes2.js';
import Store from 'store/store';
import 'store/bolt/showtimes';
// import s from 'components/bolt/showtimes/showtimes2.sss';

export default class Showtimes2 extends BaseComp.default {


	setDirections(travelMode) {
		const { mapSelectedTheater } = this.state;

		const destLat = mapSelectedTheater.lat;
		const destLng = mapSelectedTheater.lon;

		if (destLat && destLng) {
			const link = `https://www.google.com/maps/dir/?api=1&destination=${destLat},${destLng}&travelmode=${travelMode.toLowerCase()}`;
			Store.emit('MAP_REQUEST_DIRECTIONS', travelMode, mapSelectedTheater);
			window.open(link);
		}
	}
}
